<mat-dialog-content>
    Anruf: {{data.call.clientNumber}}
</mat-dialog-content>